/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type ViewerContextQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ViewerContextQuery = {
    __typename: 'Query';
    viewer: Types.Maybe<{ __typename: 'User' } & ViewerContext_UserFragment>;
};

export type ViewerContext_UserFragment = {
    __typename: 'User';
    id: string;
    displayName: string;
    isAdmin: boolean;
    isDesigner: boolean;
    designerLevel: Types.DesignerLevel;
    isCertifiedDesigner: boolean;
    isPartnershipDesigner: boolean;
    certifications: Array<string>;
};

export const ViewerContext_UserFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ViewerContext_user' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isAdmin' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDesigner' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'designerLevel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isCertifiedDesigner' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isPartnershipDesigner' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
                ],
            },
        },
    ],
};
export const ViewerContextDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ViewerContext' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'viewer' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ViewerContext_user' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'ViewerContext_user' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isAdmin' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isDesigner' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'designerLevel' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isCertifiedDesigner' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isPartnershipDesigner' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'certifications' } },
                ],
            },
        },
    ],
};

/**
 * __useViewerContextQuery__
 *
 * To run a query within a React component, call `useViewerContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerContextQuery(
    baseOptions?: Apollo.QueryHookOptions<ViewerContextQuery, ViewerContextQueryVariables>
) {
    return Apollo.useQuery<ViewerContextQuery, ViewerContextQueryVariables>(
        ViewerContextDocument,
        baseOptions
    );
}
export function useViewerContextLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ViewerContextQuery, ViewerContextQueryVariables>
) {
    return Apollo.useLazyQuery<ViewerContextQuery, ViewerContextQueryVariables>(
        ViewerContextDocument,
        baseOptions
    );
}
export type ViewerContextQueryHookResult = ReturnType<typeof useViewerContextQuery>;
export type ViewerContextLazyQueryHookResult = ReturnType<typeof useViewerContextLazyQuery>;
export type ViewerContextQueryResult = Apollo.QueryResult<
    ViewerContextQuery,
    ViewerContextQueryVariables
>;
